export const getUsersUrl = () => `/users/list`;
export const getUsersLocalUrl = () => `/admin/users`;
export const createUserLocalUrl = () => `/admin/users`;

// Fiche de l'agent connecte, rattachement annuaire compris.
export const getCurrentUserUrl = () => `/admin/users/me`;

export const getUserByIdLocalUrl = (id: string) => `/admin/users/${id}`;
export const updateUserLocalUrl = (id: string) => `/admin/users/${id}`;
export const toggleActivateUserLocalUrl = (id: string, isActivate: boolean) =>
  `/admin/users/${id}?active=${isActivate}`;

// Assign one role to one or many users
export const assignRolesToUsersUrl = () => `/admin/roles/assign-users`;

// Revoke one or many roles from a user
export const revokeRolesFromUserUrl = () => `/admin/users/revoke-roles`;

// Search user by email
export const searchLdapUserByIdUrl = (id: string) => `/admin/users/ldap/${id}`;
export const searchUserByLoginUrl = (login: string) =>
  `/admin/users/by-login/${login}`;
